module.exports = __webpack_public_path__ + "img/product_52.d37ad97.webp";